import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from 'srcReact/components/common2/Button'
import PasswordTextBox from 'srcReact/components/common2/PasswordTextBox'
import { isPasswordComplex } from 'srcReact/helpers/utils'
import { isEmpty } from 'srcReact/helpers/validator'

import styles from './styles.module.scss'

const Password = ({ setPreviousStep, previousStep, updateStep, goToPreviousStep, formState, setFormState }) => {
  const { t } = useTranslation()

  const [password, setPassword] = useState(formState.password)
  const [passwordConfirmation, setPasswordConfirmation] = useState(formState.confirmPassword)
  const [passwordError, setPasswordError] = useState('')
  const [passwordConfirmError, setPasswordConfirmError] = useState('')

  const validate = () => {
    setPasswordError('')
    setPasswordConfirmError('')
    if (isEmpty(password)) {
      setPasswordError(t('signup.password_module.error_msg_1'))
      return false
    }
    if (!isPasswordComplex(password)) {
      setPasswordError(t('signup.password_module.error_msg_2'))
      return false
    }
    if (isEmpty(passwordConfirmation)) {
      setPasswordConfirmError(t('signup.password_module.error_msg_1'))
      return false
    }

    if (password !== passwordConfirmation) {
      setPasswordConfirmError(t('signup.password_module.error_msg_3'))
      return false
    }

    return true
  }

  return (
    <div className={styles.container}>
      <div className={styles.container1}>
        <PasswordTextBox
          label={t('signup.password_module.password_pl')}
          direction='column'
          placeholder={t('signup.password_module.password_pl')}
          value={password}
          handleChange={(e) => setPassword(e.target.value)}
          errorMessage={passwordError}
        />
        <div className={styles.subtext}>{t('global.passwordSuggestion')}</div>
        <PasswordTextBox
          label={t('signup.password_module.retype_pl')}
          direction='column'
          placeholder={t('signup.password_module.retype_pl')}
          value={passwordConfirmation}
          handleChange={(e) => setPasswordConfirmation(e.target.value)}
          onBlur={validate}
          errorMessage={passwordConfirmError}
        />
      </div>
      <div className={styles.buttonContainer}>
        <Button text={t('signup.password_module.back')} size='large' style='secondary' handleClick={goToPreviousStep} />
        <Button
          type='button'
          text={t('signup.password_module.confirm')}
          size='large'
          customStyle={styles.confirmButton}
          handleClick={() => {
            if (validate()) {
              setPreviousStep([...previousStep, 'password'])
              updateStep('profileEdition')
              setFormState({
                ...formState,
                password,
                confirmPassword: passwordConfirmation
              })
            }
          }}
        />
      </div>
    </div>
  )
}
export default Password
